import * as Types from 'js/components/main/BonusHistory/hooks/useTableData/types';
import { makeConfig } from '../../../../../utils/makeConfig';
import { getRenderPopupCell } from '../cells/rowCells/getRenderPopupCell';
import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import { getRenderAccordionDefaultCell } from '../cells/rowCells/getRenderAccordionDefaultCell';
import { getRenderProgressBarCell } from '../cells/rowCells/getRenderProgressBarCell';
import { getRenderCancelMobileButton } from '../cells/buttonsRenderers/getRenderCancelButton';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { getRenderSlideCell } from '../cells/rowCells/getRenderSlideCell';
import style from '../cells/index.scss';

type GetColumnsConfigType = {
    showCancelBonusPopup: (event: React.MouseEvent<HTMLElement>, bonusName: string, bonusInstanceCode: string) => void;
    showTermsPopup: (event: React.MouseEvent<HTMLElement>, termAndConditionWebContentId: string, title: string) => void;
    translate: ITranslateMethod;
    style: Record<string, string>
}

type CellType = Types.CELL_TYPE.POPUP | Types.CELL_TYPE.GAMES | Types.CELL_TYPE.BUTTON | Types.CELL_TYPE.PROGRESS_BAR | 'default';

type ReturnedConfig = {
    id: number;
    content: React.ReactNode;
    className?: string;
}

export const getRowCellsCreator = ({
    showCancelBonusPopup,
    showTermsPopup,
    translate
}: GetColumnsConfigType) => ({ id, type, key, value }: Types.IAccordionRow) => {
    const popupRenderer = getRenderPopupCell({
        showTermsPopup,
        translate
    });
    const progressBarRenderer = getRenderProgressBarCell({
        translate
    });
    const cancelMobileButtonRenderer = getRenderCancelMobileButton({
        translate,
        showCancelBonusPopup
    });
    const slideCellRenderer = getRenderSlideCell();
    const defaultRenderer = getRenderAccordionDefaultCell({ translate });

    return makeConfig<ReturnedConfig, CellType>({
        [Types.CELL_TYPE.POPUP]: {
            id,
            content: popupRenderer(key as string, value as Pick<IBonusToDisplay, 'popupWcId' | 'popupTitle'> | undefined)
        },
        [Types.CELL_TYPE.PROGRESS_BAR]: {
            id,
            content: progressBarRenderer(key as string, value as string)
        },
        [Types.CELL_TYPE.BUTTON]: {
            id,
            content: cancelMobileButtonRenderer(value as { bonusName: string; bonusInstanceCode: string })
        },
        [Types.CELL_TYPE.GAMES]: {
            id,
            content: value ? slideCellRenderer(
                value as { playableGameTypes?: string[]; isLoading?: boolean; error?: string }
            ) : null,
            className: style.slider
        },
        default: {
            id,
            content: defaultRenderer({ name: key as string, value: value as string })
        }
    })(type as CellType);
};
